import { Star } from "lucide-react";
import VibratingButton from "@/components/base/button/VibratingButton";

type Props = {
  value?: number;
  onChange: (rating: number) => void;
  max?: number;
};

export default function RatingInput({ value = 0, onChange, max = 5 }: Props) {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: max }, (_, i) => i + 1).map((star) => {
        const isSelected = star <= value;
        return (
          <VibratingButton
            key={star}
            vibrationType="selection"
            onClick={() => onChange(star)}
            className={`flex-center p-3 rounded-xl transition-200 flex-1 ${
              isSelected
                ? "bg-[linear-gradient(83deg,rgba(251,199,108,0.08)_-31px,rgba(235,161,50,0.08)_100px)] border border-orange-100/30"
                : "bg-white/08 border border-transparent"
            }`}
          >
            <Star
              className={`w-7 h-7 transition-200 ${
                isSelected
                  ? "fill-orange-100 text-orange-100"
                  : "fill-transparent text-white/20"
              }`}
              strokeWidth={1.5}
            />
          </VibratingButton>
        );
      })}
    </div>
  );
}
